"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastCalledController = void 0;
const value_observer_1 = require("@dqm/value-observer");
const react_1 = __importStar(require("react"));
function getCurrentValue(provider) {
    if (provider.getStatus() === value_observer_1.ValueStatus.Ok) {
        return provider.getValue();
    }
    return { items: [], next: null };
}
function animateNewLastCalled(item, animator) {
    return __awaiter(this, void 0, void 0, function* () {
        if (item && animator) {
            return animator.queue("last-called-item", item);
        }
        return;
    });
}
const LastCalledController = ({ children, valueService, animationController, }) => {
    const lastCalledProvider = valueService.getProvider("last-called");
    const { items: currentItems } = getCurrentValue(lastCalledProvider);
    const [values, setValues] = (0, react_1.useState)({
        items: currentItems,
        status: lastCalledProvider.getStatus(),
    });
    (0, react_1.useEffect)(() => {
        const unregister = valueService.registerListener("last-called", (provider) => __awaiter(void 0, void 0, void 0, function* () {
            const { items, next: next } = getCurrentValue(provider);
            yield animateNewLastCalled(next, animationController);
            setValues({ items: items, status: provider.getStatus() });
        }));
        return () => {
            unregister();
        };
    }, [valueService]);
    if (typeof children !== "function") {
        return null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children(Object.assign({}, values)));
};
exports.LastCalledController = LastCalledController;
//# sourceMappingURL=LastCalledController.js.map